module.exports = "/assets/d7e1b8606da64d9de07ef5536ba83b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UL.png
// module id = 3014
// module chunks = 0